var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModeNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7461_18963",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7461_18963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7971 17.17C12.7614 17.17 12.7243 17.1668 12.6857 17.1598C10.9156 16.8372 9.25677 15.9159 8.01431 14.5658C6.71522 13.1544 6 11.3907 6 9.6001C6 7.8095 6.70965 5.98038 7.99806 4.56758C9.24842 3.19702 10.9318 2.28779 12.7377 2.007C12.9712 1.9708 13.1907 2.07708 13.2965 2.27851C13.3587 2.39686 13.4288 2.63728 13.1963 2.91297C13.1568 2.95985 13.1062 3.01369 13.0417 3.08145C12.4397 3.71916 10.6078 5.65921 10.6078 9.59964C10.6078 13.5401 12.4128 15.4323 13.006 16.0728C13.0737 16.1461 13.1276 16.2042 13.1689 16.2543C13.4019 16.5379 13.3272 16.7792 13.2622 16.898C13.1893 17.0312 13.0278 17.1695 12.7967 17.1695L12.7971 17.17ZM11.4377 3.40959C10.4241 3.80502 9.50044 4.43623 8.75273 5.25588C7.63604 6.47978 7.02108 8.02254 7.02108 9.6001C7.02108 11.1777 7.64069 12.6522 8.76526 13.8742C9.5023 14.6749 10.4046 15.3037 11.3899 15.7154C10.5721 14.563 9.58677 12.5993 9.58677 9.59964C9.58677 7.75427 9.96178 6.07924 10.7016 4.62096C10.9443 4.14198 11.1991 3.74051 11.4377 3.40912V3.40959Z",
    fill: "#010101"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeNight);
export default __webpack_public_path__ + "static/media/mode_night.813b3863f2c4d8e123a4f770b04a3d4a.svg";
export { ForwardRef as ReactComponent };